import {
  UserRound,
  ShieldPlus,
  Microscope,
  HeartHandshake,
  MessageSquareMore,
  ChevronRight,
  Menu,
  X,
  ArrowRight,
  ChevronLeft,
  ChevronUp,
  ChevronDown,
} from "lucide-react";

import IconAbout from "../icons/icon-about.png";
import IconCapabilities from "../icons/icon-capabilities.png";
import IconTestimonials from "../icons/icon-testimonials.png";
import IconContact from "../icons/icon-contact.png";

export const Icons = {
  User: () => <UserRound size={18} />,
  ShieldPlus: () => <ShieldPlus size={36} />,
  Microscope: () => <Microscope size={36} />,
  HeartHandshake: () => <HeartHandshake size={36} />,
  MessageSquareMore: (props: { className?: string; size?: number }) => (
    <MessageSquareMore size={props.size ?? 36} className={props.className} />
  ),
  ChevronLeft: (props: { className?: string; size?: number }) => (
    <ChevronLeft size={props.size ?? 18} className={props.className} />
  ),
  ChevronRight: () => <ChevronRight size={18} />,
  ChevronUp: (props: { className?: string; size?: number }) => (
    <ChevronUp size={props.size ?? 18} className={props.className} />
  ),
  ChevronDown: (props: { className?: string; size?: number }) => (
    <ChevronDown size={props.size ?? 18} className={props.className} />
  ),
  Menu: () => <Menu size={18} />,
  Close: () => <X size={18} />,
  ArrowRight: (props: {
    className?: string;
    size?: number;
    strokeWidth?: number;
  }) => (
    <ArrowRight
      size={props.size ?? 18}
      className={props.className}
      strokeWidth={props.strokeWidth ?? 2}
    />
  ),
  IconAbout: () => (
    <img src={IconAbout} alt="Two lab flasks" className="w-12" />
  ),
  IconCapabilities: () => (
    <img src={IconCapabilities} alt="A burner used in a lab" className="w-12" />
  ),
  IconTestinonials: () => (
    <img src={IconTestimonials} alt="A heart" className="w-12" />
  ),
  IconContact: () => (
    <img src={IconContact} alt="Two speech bubbles" className="w-12" />
  ),
};
